<script>
  export let style='';
</script>
<div class='container' {style}>
  <main>
    <slot></slot>
  </main>
</div>

<style>
  .container {
    background-color: var(--background);
    width: 100%;
  }
  main {
    margin: 0 auto;
    padding: 15px;
    max-width: 1200px;
  }
</style>